export function generateRouteKey(pathname: string, refreshParam?: 'true' | 'false' | undefined) {
  if (pathname.includes('/settings')) {
    return '/settings';
  }
  if (pathname.includes('/communications')) {
    return '/communications';
  }
  if (pathname.includes('/reports')) {
    return '/reports';
  }
  return pathname;
}
